import * as React from 'react';

const MoneyTransferIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={16}>
    <path
      fill={fillColor}
      d="M1.916 13.667a1.2 1.2 0 0 1-.875-.375 1.2 1.2 0 0 1-.375-.875V1.583a1.2 1.2 0 0 1 .375-.875 1.2 1.2 0 0 1 .875-.375h14.167a1.2 1.2 0 0 1 .875.375c.25.25.375.542.375.875v4.98H1.916v5.854h7.688c.177 0 .325.06.445.18s.18.27.18.448-.06.327-.18.445a.61.61 0 0 1-.445.177H1.916Zm0-10h14.167V1.583H1.916v2.084Zm13.333 9.166h-1.875a.603.603 0 0 1-.445-.18.61.61 0 0 1-.18-.448.61.61 0 0 1 .625-.621h1.875V9.707c0-.177.06-.325.181-.445a.61.61 0 0 1 .448-.18.61.61 0 0 1 .621.625v1.875h1.875c.177 0 .326.06.446.181.12.12.18.27.18.448s-.06.326-.18.444a.61.61 0 0 1-.446.177H16.5v1.875c0 .178-.06.326-.18.446a.61.61 0 0 1-.448.18.61.61 0 0 1-.621-.625v-1.876Z"
    />
  </svg>
);

export default MoneyTransferIcon;
